import { graphql, useStaticQuery } from 'gatsby';

import { EmployeeQuery } from './__generated__/EmployeeQuery';
import React from 'react';
import Img from 'gatsby-image';

const EmployeeImage = ({ image, title, name, email, description, description2 }) => {
  return (
    <div className="w-full md:w-1/2 xl:w-1/3 text-center mb-4 md:mb-8 px-2 md:px-8">
      <Img fluid={image} alt={name + ' ' + description + ' ' + description2} />
      <div className="text-center">
        <p>{title}</p>
        <h6>{name}</h6>
        <a className="text-sm" href={`mailto:${email}`}>
          {email}
        </a>
        {description && <p className="text-sm font-semibold">{description}</p>}
        {description2 && <p className="text-sm">{description2}</p>}
      </div>
    </div>
  );
};

export const Team = () => {
  const data: EmployeeQuery = useStaticQuery(graphql`
    query EmployeeQuery {
      items: allEmployeeJson {
        edges {
          node {
            id
            name
            title
            email
            description
            description2
            baseImagePath
            localFile {
              childImageSharp {
                id
                fluid(maxWidth: 720) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
      }
    }
  `);

  return (
    <section>
      <div className="flex flex-wrap justify-center">
        {data.items.edges.map(({ node }) => (
          <EmployeeImage
            key={node.id}
            title={node.title}
            name={node.name}
            email={node.email}
            description={node.description}
            description2={node.description2}
            image={node.localFile ? node.localFile.childImageSharp.fluid : null}
          />
        ))}
      </div>
    </section>
  );
};
